import { render, staticRenderFns } from "./RequestQuotation.vue?vue&type=template&id=0723f8b2&scoped=true&"
import script from "./RequestQuotation.vue?vue&type=script&lang=js&"
export * from "./RequestQuotation.vue?vue&type=script&lang=js&"
import style0 from "./RequestQuotation.vue?vue&type=style&index=0&id=0723f8b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723f8b2",
  null
  
)

export default component.exports